import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';

const Header = () => {
    const navigate = useNavigate();
    const { user, logout, isAuthenticated } = useAuth();
    const [menuOpen, setMenuOpen] = useState(false);

    const handleLogout = () => {
        logout();
        navigate('/');
        setMenuOpen(false);
    };

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (
        <header className="header">
            <div className="header-container">
                
                {/* Logo */}
                <Link to="/" className="logo" onClick={closeMenu}>
                    <span className="logo-icon">🎓</span>
                    <span className="logo-text">VTYM Douane</span>
                </Link>

                {/* Menu Hamburger pour mobile */}
                <button 
                    className={`menu-toggle ${menuOpen ? 'active' : ''}`}
                    onClick={toggleMenu}
                    aria-label="Toggle menu"
                >
                    <span className="hamburger"></span>
                    <span className="hamburger"></span>
                    <span className="hamburger"></span>
                </button>

                {/* Navigation */}
                <nav className={`nav ${menuOpen ? 'nav-open' : ''}`}>
                    
                    {/* Menu principal */}
                    <Link to="/" className="nav-link" onClick={closeMenu}>
                        Accueil
                    </Link>
                    
                    <Link to="/formations" className="nav-link" onClick={closeMenu}>
                        Formations
                    </Link>
                    
                    <Link to="/sessions" className="nav-link sessions-link" onClick={closeMenu}>
                        <span className="live-dot"></span>
                        Sessions Live
                    </Link>
                    
                    <Link to="/articles" className="nav-link" onClick={closeMenu}>
                        Articles
                    </Link>
                    
                    {/* Section authentification */}
                    <div className="auth-section">
                        {isAuthenticated ? (
                            <>
                                <Link 
                                    to="/dashboard" 
                                    className="btn-dashboard"
                                    onClick={closeMenu}
                                >
                                    <span className="user-icon">👤</span>
                                    <span className="user-name">
                                        {user?.name || user?.email?.split('@')[0] || 'Mon compte'}
                                    </span>
                                </Link>
                                <button 
                                    onClick={handleLogout}
                                    className="btn-logout"
                                >
                                    Déconnexion
                                </button>
                            </>
                        ) : (
                            <>
                                <Link 
                                    to="/login" 
                                    className="btn-login"
                                    onClick={closeMenu}
                                >
                                    Connexion
                                </Link>
                                <Link 
                                    to="/register" 
                                    className="btn-register"
                                    onClick={closeMenu}
                                >
                                    S'inscrire
                                </Link>
                            </>
                        )}
                    </div>
                </nav>

            </div>
        </header>
    );
};

export default Header;